<template>
    <modal class="tipModal" :isShow="isShow" @mousedown.prevent @keyup.esc="hide">
        <div class="header">温馨提示</div>
        <div class="modal-body">
            <i class="iconfont icon-zhuyi"></i>
            <div class="title">{{data?.title}}</div>
            <div class="text">{{data?.text}}</div>
        </div>
        <div class="footer-box">
            <div class="btn btn-confirm" @click="hide">确认</div>
        </div>
    </modal>
</template>

<script>
export default {
    emits:["close","success"],
    props:{
        isShow:{
            type:Boolean,
            default:false
        },
        data:{
            type:Object,
            default:null
        }
    },
    watch:{
        isShow(newVal){
            if(newVal){
                this.init();
            }
        },
    },
    data(){
        return {
        }
    },
    mounted(){
        
    },
    methods:{
        hide(){
            this.$emit('close');
        },
    }  
}
</script>

<style lang="scss" >
.tipModal{
    .modal-dialog{ 
        width: 500px;
        max-width: 500px;
       
        .modal-content{
            right: inherit;
            width: 100%;
            border-radius: 8px;
            padding-bottom: 28px;
        }
    }
 
    .header{
        background: #C3D9EA;
        height: 45px;
        line-height: 45px;
        padding-left: 30px;
        border-radius: 8px;
        border-bottom-left-radius:0 ;
        border-bottom-right-radius:0 ;
        font-weight: bold;
        font-size: 18px;
        font-weight: 400;
        color: #000000;
    }

    .modal-body{
        padding-top: 20px;
        min-height: 240px;

        text-align: center;

        .iconfont{
            color: #FFAA00;
            font-size: 100px;
        }

        .title{
            margin-top: 7px;
            font-weight: 500;
            font-size: 22px;
            color: #141414;
        }

        .text{
            margin-top: 18px;
            font-weight: 500;
            font-size: 16px;
            color: #333333;
            white-space: pre-wrap;
        }
    }

    .footer-box{
        padding: 0 15px;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;

        .btn{
            padding: 0;
            background: #DBE0EB;
            border-radius: 7px;
            width: 300px;
            height: 50px;
            line-height: 48px;
            text-align: center;
            font-weight: 400;
            font-size: 20px;
            color: #1C344A;
            border: 1px solid #DBE0EB;
        }

        .btn-confirm{
            background: linear-gradient( 180deg, #086AA2 0%, #318CC4 100%);
            border: 1px solid #0581C3;
            color: #fff;
        }
    }
}
</style>